import ExpressionHarness from 'bundles/author-code-evaluator/models/ExpressionHarness';

export const TestCaseHarnessClassName = 'org.coursera.eval.evaluator.TestCaseHarness';

class TestCaseHarness extends ExpressionHarness {
  declare testCase: string;

  static TestCaseHarnessClassName = TestCaseHarnessClassName;

  constructor({ preamble, testCase }: { preamble: string; testCase: string }) {
    super({ preamble });
    this.testCase = testCase;
  }

  toJSON(): RawTestCaseHarness {
    return {
      'org.coursera.eval.evaluator.TestCaseHarness': {
        preamble: this.preamble,
        testCase: this.testCase,
      },
    };
  }
}

export type RawTestCaseHarness = {
  'org.coursera.eval.evaluator.TestCaseHarness': {
    preamble: string;
    testCase: string;
  };
  'org.coursera.eval.evaluator.ReplHarness'?: void;
};

export default TestCaseHarness;
